import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';
import { FeedbackDialogModalComponent } from '../feedback-dialog-modal/feedback-dialog-modal.component';

@Component({
  selector: 'pla-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.css'],
})
export class FeedbackModalComponent implements OnInit {
  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  public openModal(): void {
    this.dialog.open(FeedbackDialogModalComponent, {
      width: '420px',
      maxWidth: '92vw',
      data: { context: { source: 'sidebar' } },
    });
  }
}
